import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from 'shared-ui/lib/components/Button';
import { TableColumn } from 'shared-ui/lib/customs/react/generic-table/TableColumn';
import { formatDate } from 'shared-ui/lib/utils/format-date';
import { routesConfig } from '../config/routes.config';
import { PartnerCustomersQuery } from '../generated/graphql';

type CustomerRow = PartnerCustomersQuery['partnerCustomers']['list'][0];

const GoToVehiclesLink = ({ businessId }: { businessId: string }): JSX.Element => {
  const { t } = useTranslation('ServiceCallCustomersScene');

  return (
    <Link
      to={routesConfig.SERVICE_CALL.CUSTOMER_VEHICLES.replace(':businessId', businessId)}
      className="text-primary hover:text-secondary font-semibold underline"
    >
      {t('goToVehicles')}
    </Link>
  );
};

const EndCustomerButton = ({
  customer,
  onEnd,
}: {
  customer: CustomerRow;
  onEnd: (customer: CustomerRow) => void;
}): JSX.Element => {
  const { t } = useTranslation('ServiceCallCustomersScene');

  return (
    <Button type="button" onClick={() => onEnd(customer)}>
      {t('endCustomer')}
    </Button>
  );
};

const businessName: TableColumn = {
  field: 'businessName',
  text: 'ServiceCallCustomersScene:businessName',
  sort: true,
};

const vehicleCount: TableColumn = {
  field: 'vehicleCount',
  text: 'ServiceCallCustomersScene:vehicleCount',
  sort: true,
};

const startedAt: TableColumn = {
  field: 'startedAt',
  text: 'ServiceCallCustomersScene:startedAt',
  sort: true,
  default: '-',
  formatter: (data: CustomerRow) => (data.startedAt ? formatDate(data.startedAt) : '-'),
};

const goToVehicles: TableColumn = {
  field: 'businessId',
  text: 'ServiceCallCustomersScene:vehicles',
  formatter: (data: CustomerRow) => <GoToVehiclesLink businessId={data.businessId} />,
};

const endCustomer = (onEnd: (customer: CustomerRow) => void): TableColumn => ({
  field: 'id',
  text: 'ServiceCallCustomersScene:endCustomer',
  formatter: (data: CustomerRow) => <EndCustomerButton customer={data} onEnd={onEnd} />,
});

export const partnerCustomerColumns = {
  businessName,
  vehicleCount,
  startedAt,
  goToVehicles,
  endCustomer,
};
